var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../assets/images/arrow.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };